module.exports = __webpack_public_path__ + "static/media/OnVacation.0db6e350.svg";